'use client';
import React from 'react';
import ProgressBar from '@/components/ProgressBar';
import dynamic from 'next/dynamic';

const RenewalChart = dynamic(() => import('@/app/customer-success/components/RenewalDonutChart'), { ssr: false });

const renewalBreakdown = [
  { id: 'mb-booked',  label: 'Booked', count: 412, pct: 64, color: 'success' as const, amount: '$94,348' },
  { id: 'mb-pending', label: 'Pending', count: 184, pct: 29, color: 'warning' as const, amount: '$42,136' },
  { id: 'mb-lost',    label: 'Lost', count: 46, pct: 7, color: 'danger' as const, amount: '$10,534' },
];

const topZones = [
  { id: 'tz-irvine', zone: 'Irvine', renewals: 124, rate: '91%' },
  { id: 'tz-anaheim', zone: 'Anaheim', renewals: 98, rate: '86%' },
  { id: 'tz-cm', zone: 'Costa Mesa', renewals: 77, rate: '82%' },
  { id: 'tz-santa-ana', zone: 'Santa Ana', renewals: 68, rate: '79%' },
  { id: 'tz-tustin', zone: 'Tustin', renewals: 45, rate: '88%' },
];

export default function MembershipRenewalPanel() {
  return (
    <div className="bg-card rounded-lg card-shadow border border-border">
      <div className="px-5 py-4 border-b border-border">
        <h3 className="text-sm font-semibold text-foreground">Maintenance Membership Renewals</h3>
        <p className="text-xs text-muted-foreground mt-0.5">642 customers · 84% renewal rate · $229/yr avg</p>
      </div>
      <div className="px-5 py-4">
        <div className="flex items-center justify-between mb-4">
          <RenewalChart />
          <div className="flex-1 ml-4 space-y-3">
            {renewalBreakdown.map((r) => (
              <div key={r.id}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-muted-foreground">{r.label}</span>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-tabular text-foreground font-medium">{r.count}</span>
                    <span className="text-xs font-tabular text-success font-semibold">{r.amount}</span>
                  </div>
                </div>
                <ProgressBar value={r.count} max={642} color={r.color} size="md" />
              </div>
            ))}
          </div>
        </div>

        <div className="pt-3 border-t border-border">
          <div className="text-xs font-semibold text-foreground mb-2">Renewals by Zone</div>
          <div className="space-y-1.5">
            {topZones.map((z) => (
              <div key={z.id} className="flex items-center justify-between text-xs">
                <span className="text-muted-foreground">{z.zone}</span>
                <div className="flex items-center gap-3">
                  <span className="font-tabular text-foreground">{z.renewals} renewed</span>
                  <span className="font-semibold text-success font-tabular">{z.rate}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-3 pt-3 border-t border-border grid grid-cols-2 gap-3 text-xs">
          <div className="bg-success/5 border border-success/20 rounded-md p-2 text-center">
            <div className="font-bold text-success text-base font-tabular">$146,918</div>
            <div className="text-muted-foreground">Projected annual</div>
          </div>
          <div className="bg-secondary/5 border border-secondary/20 rounded-md p-2 text-center">
            <div className="font-bold text-secondary text-base font-tabular">84%</div>
            <div className="text-muted-foreground">Renewal rate</div>
          </div>
        </div>
      </div>
    </div>
  );
}